export function phoneCountryField() {
    const editAdressModal = document.getElementById("editAddressModal");
    if(editAdressModal) {
        const phoneNo = editAdressModal.querySelector("#input_phone_no");
        const completePhone = editAdressModal.querySelector(".js-phoneCountryFieldHidden");

        if(phoneNo && completePhone) {
            editAdressModal.addEventListener("submit", function () {
                if(phoneNo.value == "") {
                    completePhone.value = "";
                }
            });
        }

    }
}